import React from 'react';
import style from './index.module.scss';
import { useRouter } from 'next/router';
import H5Image from 'web-materials/dist/esm/components/common/H5Image';
import LogDiv from '@/commonComponents/logDiv';

export default () => {
  const router = useRouter();

  return (
    <LogDiv className={style.wrapper} impr="duet_phone_website_purchase_success_page">
      <H5Image
        type="origin"
        className={style.back}
        onClick={() => router.push('/playground_mobile')}
        src="https://cdn.duetapp.net/v1/images/eyJpZCI6IlZZWEhOVlpMNlFDUEJaNUVEWlNBRFBBRFdMT01OSCIsInciOjU2LCJoIjo1NiwiZCI6MCwibXQiOiJpbWFnZS9qcGVnIiwiZGgiOjU2NjI1MjgwMDI0NjI3Mn0"
        alt=""
      />
      <H5Image
        type="origin"
        className={style.res}
        src="https://cdn.duetapp.net/v1/images/eyJpZCI6IlVNREtIR1RNUEsyMkhVM1E0SkEzUU0zUzVXWEpSVCIsInciOjIyNiwiaCI6MTkyLCJkIjowLCJtdCI6ImltYWdlL2pwZWciLCJkaCI6MTM0OTg1NzgxNzYxMzI0MjkzNTV9"
        alt=""
      />
      <div className={style.title}>Payment Successful</div>
      <div className={style.content}>
        Payment successful! Your subscription is now active. Return to the Duet App to enjoy your upgrade! Your
        subscription will automatically renew for the same period each term. To manage your subscription, please visit
        Settings in the app. For full purchase terms, see:{' '}
        <a href="https://duetapp.net/terms" target="_blank" rel="noreferrer">
          https://duetapp.net/terms
        </a>
        .
      </div>
      <a
        href="https://duet.onelink.me/GBnZ/t3682sma"
        className={style.button}
        target="_blank"
        rel="noreferrer"
        suppressHydrationWarning
      >
        OK
      </a>
    </LogDiv>
  );
};
